/**
 * @file content-summary.ts
 * @description Сводки свёрнутых групп вкладки «Содержимое» секции
 * (phase19.16, SB122; uiux-settings-groups §5 шаг 4): «Шапка раздела» —
 * заголовок раздела в кавычках или «без заголовка»; «Колонки и элементы» —
 * «3 колонки · 7 элементов».
 */

import type { SectionPayload } from "@chaiberi/shared";

import { pluralRu } from "../plural";
import { columnsLabel } from "./section-meta";

/** Сводка «Шапки раздела»: заголовок в кавычках или «без заголовка». */
export function headerSummary(header: SectionPayload["header"]): string {
  const title = header?.title.trim();
  return title ? `«${title}»` : "без заголовка";
}

/** Сводка «Колонок и элементов»: «3 колонки · 7 элементов». */
export function gridSummary(columns: SectionPayload["columns"]): string {
  const elements = columns.items.reduce((sum, col) => sum + col.elements.length, 0);
  return `${columnsLabel(columns.items.length)} · ${elements} ${pluralRu(elements, ["элемент", "элемента", "элементов"])}`;
}
